import { useState, useCallback } from 'react';
import { useIntl, defineMessages } from 'react-intl';
import ToastrService from '@/shared/services/ToastrService';
import handleHttpError from '@/shared/services/HandleHttpError';
import useExtractDocumentDataPreview from './useExtractDocumentDataPreview';
var messages = defineMessages({
    DocumentDataExtracted: {
        id: 'DocumentDataExtracted',
        defaultMessage: 'Data extracted successfully',
    },
    DocumentDataExtractionFailed: {
        id: 'DocumentDataExtractionFailed',
        defaultMessage: 'Failed to extract data',
    },
    DocumentDataExtractionInsufficientData: {
        id: 'DocumentDataExtractionInsufficientData',
        defaultMessage: 'Not enough data found in the document to continue processing',
    },
});
var useDocumentExtraction = function (_a) {
    var onExtracted = _a.onExtracted;
    var intl = useIntl();
    var extractMutation = useExtractDocumentDataPreview();
    var _b = useState(null), extractingDocumentId = _b[0], setExtractingDocumentId = _b[1];
    var _c = useState(null), extractedFromDocumentId = _c[0], setExtractedFromDocumentId = _c[1];
    var handleExtractDocument = useCallback(function (documentId) {
        setExtractingDocumentId(documentId);
        extractMutation.mutate(documentId, {
            onSuccess: function (data) {
                setExtractingDocumentId(null);
                if (!data.success) {
                    ToastrService.error(intl.formatMessage(messages.DocumentDataExtractionFailed));
                    return;
                }
                if (data.code === 18002 || !data.extractedData) {
                    ToastrService.info(intl.formatMessage(messages.DocumentDataExtractionInsufficientData));
                    return;
                }
                onExtracted(data.extractedData, documentId);
                setExtractedFromDocumentId(documentId);
                ToastrService.success(intl.formatMessage(messages.DocumentDataExtracted));
            },
            onError: function (error) {
                setExtractingDocumentId(null);
                handleHttpError(intl)(error);
            },
        });
    }, [extractMutation, intl, onExtracted]);
    return { extractingDocumentId: extractingDocumentId, extractedFromDocumentId: extractedFromDocumentId, handleExtractDocument: handleExtractDocument };
};
export default useDocumentExtraction;
